export const EXTRA_ACTIVITIES_TEXT = {
	title: 'Extra activities',
	addActivityAriaLabel: 'Add extra activity',
	collapseActivityAriaLabel: 'Collapse extra activities',
	expandActivityAriaLabel: 'Expand extra activities',
	durationUnit: 'min',
	actionsAriaLabel: 'Extra activity actions',
	editAction: 'Edit',
	removeAction: 'Remove',
};
